import { render, staticRenderFns } from "./RoomClosedMeeting.vue?vue&type=template&id=6b99d91c"
import script from "./RoomClosedMeeting.vue?vue&type=script&lang=js"
export * from "./RoomClosedMeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports